import { Injectable } from "@angular/core";

/**
 * Serviço responsável por inicializar o onboarding quando o usuário
 * é redirecionado do app principal
 */
@Injectable({
  providedIn: "root",
})
export class OnboardingInitService {
  /**
   * Inicializa o onboarding verificando se existem dados temporários
   * vindos do app principal
   * @returns true se foi inicializado com dados do app principal, false caso contrário
   */
  initializeOnboarding(): boolean {
    try {
      const onboardingToken = this.getCookie("onboarding_token");
      const onboardingUser = this.getCookie("onboarding_user");

      if (onboardingToken && onboardingUser) {
        // Migrar dados para o localStorage principal
        localStorage.setItem("token", onboardingToken);
        localStorage.setItem("user", onboardingUser);

        // Limpar cookies temporários
        this.deleteCookie("onboarding_token");
        this.deleteCookie("onboarding_user");

        return true;
      }

      return false;
    } catch (error) {
      console.error("OnboardingInitService - Erro ao inicializar:", error);
      return false;
    }
  }

  /**
   * Verifica se o usuário está vindo do app principal
   * @returns true se tem dados de onboarding, false caso contrário
   */
  hasOnboardingData(): boolean {
    return !!(this.getCookie("onboarding_token") && this.getCookie("onboarding_user"));
  }

  /**
   * Limpa todos os dados de onboarding (útil para logout ou reset)
   */
  clearOnboardingData(): void {
    this.deleteCookie("onboarding_token");
    this.deleteCookie("onboarding_user");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }

  /**
   * Lê um cookie específico
   * @param name Nome do cookie
   * @returns Valor do cookie ou null se não existir
   */
  private getCookie(name: string): string | null {
    const nameEquals = name + "=";
    const cookiesArray = document.cookie.split(";");
    for (const cookieRaw of cookiesArray) {
      let cookie = cookieRaw;
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEquals) === 0) {
        return cookie.substring(nameEquals.length, cookie.length);
      }
    }
    return null;
  }

  /**
   * Remove um cookie específico
   * @param name Nome do cookie a ser removido
   */
  private deleteCookie(name: string): void {
    const isProduction =
      !window.location.hostname.includes("localhost") &&
      !window.location.hostname.includes("127.0.0.1");

    let cookieString = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;

    if (isProduction) {
      // Em produção, usar domínio compartilhado
      cookieString += ";domain=.yooga.com.br";
    }
    // Em desenvolvimento, não especificar domínio (funciona para localhost)

    document.cookie = cookieString;
  }
}
